import React from "react";

var sendSvg = function sendSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.108 9.784L7 8.1 1.162 6.432.031 2.042A.998.998 0 0 1 .781.83a1.06 1.06 0 0 1 .688.065l14.064 6.394c.285.13.467.408.467.713a.785.785 0 0 1-.467.712L1.47 15.109a1.045 1.045 0 0 1-1.371-.481.973.973 0 0 1-.067-.667z",
    fillRule: "evenodd"
  }));
};

sendSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var send = {
  category: 'icon',
  colorable: true,
  name: 'send',
  svg: sendSvg
};